<template>
  <section class="p-2">
    <div class="card shadow-sm bg-light">
      <div class="card-body">
        <div class="d-flex justify-content-start align-items-center">
          <div>
            <i class="fa-solid fa-robot fa-md"></i>
          </div>
          <div class="pl-2"><slot name="ai-title">title</slot></div>
          <div class="pl-2 flex-grow-1 text-right">
            <span v-show="isLoading && assistantFeature === 'image_description'">
              <i class="fa-solid fa-xl fa-compact-disc fa-flip"></i>
            </span>
          </div>
        </div>

        <!-- AI summary conversation -->
        <div v-if="assistantFeature !==  'translate'">
          <summary-conversation :selectedConversation="selectedConversation" v-if="departmentIds.includes(admin.department_id)" />
        </div>
        <!-- AI assistant features -->
        <transition name="fade">
          <div v-if="assistantFeature === 'image_description'">
            <image-description />
          </div>
          <div v-if="assistantFeature === 'function_calling'">
            <function-calling />
          </div>
          <div v-if="assistantFeature === 'translate'">
            <Translate />
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FunctionCalling from '@/components/aiAssistant/components/FunctionCalling'
import ImageDescription from '@/components/aiAssistant/components/ImageDescription'
import SummaryConversation from '@/components/aiAssistant/components/SummaryConversation'
import Translate from '@/components/aiAssistant/components/Translate'

export default {
  props: {
    selectedConversation: Object
  },
  components: {
    FunctionCalling,
    ImageDescription,
    SummaryConversation,
    Translate
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('admin', ['admin']),
    ...mapState('aiAssistant', ['assistantFeature', 'departmentIds', 'isLoading']),
    ...mapState('conversation', ['customerType'])
  },
  watch: {
    conversation () {
      if (this.conversation.id !== this.activeConversationId) {
        this.activeConversationId = this.conversation.id
        this.showSummary = true
        this.summaryText = null
      }
    },
    // Watch customerType value
    customerType (newVal, oldVal) {
      if (newVal !== oldVal) {
        // console.log(`customerType changed from ${oldVal} to ${newVal}`)
        this.handleCustomerTypeChange()
      }
    }
  },
  methods: {
    ...mapActions('professional', ['searchProfessionals']),
    // set SET_ASSISTANT_FEATURE store by customerType
    handleCustomerTypeChange () {
      if (this.customerType === 'recruitment_customer' || this.customerType === 'recruitment_professional') {
        this.$store.commit('aiAssistant/SET_ASSISTANT_FEATURE', 'translate')
      } else {
        this.$store.commit('aiAssistant/SET_ASSISTANT_FEATURE', 'chat')
      }
    }
  },
  mounted () {
    // Active when change customerType
    this.handleCustomerTypeChange()
    this.$store.commit('aiAssistant/SET_CUSTOMER_MESSAGE', null)
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.summary-text {
  white-space: pre-line;
}
</style>
